import { z } from 'zod';

// The same seeded identity used by the loopback walk.
export const DEMO_WALK_IDENTITY = { tenantId: 'helix_retail', userId: 'e2e-admin' } as const;
export const PUBLIC_DEMO_PROXY_HEADER = 'x-helix-demo-proxy-key';
const authoritySchema = z.string().regex(/^[a-z0-9.-]+(?::[0-9]+)?$/i);
const ipSchema = z.string().ip();

function dnsAuthority(host: string | null | undefined): URL | null {
  if (!host || !authoritySchema.safeParse(host).success) return null;
  try {
    const authority = new URL(`http://${host}`);
    return ipSchema.safeParse(authority.hostname).success ? null : authority;
  } catch (cause) {
    if (cause instanceof TypeError) return null;
    throw Object.defineProperty(new Error('Could not parse demo request authority'),
      'cause', { value: cause, writable: true, configurable: true });
  }
}

export function listedDemoHostAuthority(host: string | null | undefined,
  configuredHosts: string | undefined): URL | null {
  if (!configuredHosts?.trim()) return null;
  const authority = dnsAuthority(host);
  if (!authority) return null;
  const listed = configuredHosts.split(',').some(entry => {
    const name = entry.trim().toLowerCase();
    return name === authority.hostname && dnsAuthority(name)?.hostname === name;
  });
  return listed ? authority : null;
}

export const PUBLIC_DEMO_CREDENTIAL_HEADERS = ['x-company-id', 'x-user-id',
  'x-helix-test-user', 'x-helix-admin-key', 'x-roles', 'x-role', 'authorization', 'cookie',
  PUBLIC_DEMO_PROXY_HEADER] as const;
